import { AdminModalBodyProps } from './admin-modal-body-props';
import React from 'react';
import styled from 'styled-components';

type ComponentType = React.FunctionComponent<AdminModalBodyProps>;

export const AdminModalBody = styled.div<ComponentType>`
  flex: 1;
  margin-top: 1rem;
  padding: 0 1rem;
`;
